import { keys, reduce } from 'ramda';

export const parseErrors = (errors: { [key: string]: [] }) => {
  const validErrors = reduce(
    (aaccumulator: any, currentValue: any) => {
      if (currentValue === 'non_field_errors' || currentValue === 'detail') {
        return {
          ...aaccumulator,
          // eslint-disable-next-line no-useless-computed-key
          ['_error']:
            errors[currentValue] && Array.isArray(errors[currentValue])
              ? errors[currentValue].join()
              : errors[currentValue],
        };
      }
      return {
        ...aaccumulator,
        [currentValue]:
          errors[currentValue] && Array.isArray(errors[currentValue])
            ? errors[currentValue].join()
            : errors[currentValue],
      };
    },
    {},
    keys(errors)
  );
  return validErrors;
};

export const errorsValidation = {
  is400Group: function (status: number): boolean {
    return status >= 400 && status < 500;
  },
};

export function parseErrorsToFormik(errors: {
  [key: string]: string[] | string;
}) {
  return reduce(
    (aaccumulator: any, currentValue: string) => {
      return {
        ...aaccumulator,
        [currentValue]: Array.isArray(errors[currentValue])
          ? (errors[currentValue] as string[]).join(' ')
          : errors[currentValue],
      };
    },
    {},
    keys(errors)
  );
}
